import React from 'react'
import { Button } from 'antd'
import classnames from 'classnames'
import { injectIntl } from 'react-intl'
import LegalInfoModal from 'components/LegalInfoModal'
import style from './styles.module.scss'

const COOKIES_AGREEMENT_KEY = 'cookies_agreement_signed';

class CookiesPolicyAgreement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hidden: localStorage.getItem(COOKIES_AGREEMENT_KEY) !== null || false
    }
  }

  onClose = () => this.setState({ hidden: true }, () => localStorage.setItem(COOKIES_AGREEMENT_KEY, true))

  render() {
    if (this.state.hidden) {
      return null;
    }

    const { intl: { formatMessage } } = this.props;

    return (
      <div className={classnames(style.wrapper, { [style.hidden]: this.state.hidden, [style.visible]: !this.state.hidden })}>
        <div className={style.content}>
          <div className={style.text}>
            {formatMessage({ id: 'components.cookies-policy-agreement.text' })}&nbsp;
            <LegalInfoModal
              label={formatMessage({ id: 'components.cookies-policy-agreement.docs-link-text' })}
              className={style.legalLink}
            />
          </div>
          <Button onClick={this.onClose}>
            {formatMessage({ id: 'components.cookies-policy-agreement.agree-button' })}
          </Button>
        </div>
      </div>
    )
  }
}

export default injectIntl(CookiesPolicyAgreement)
